import { Component } from '@angular/core'

@Component({
  template: `
    <div class="expired-page" fxLayout="column" fxLayoutAlign="center center">
      <mat-icon svgIcon="error"></mat-icon>
      <div class="title">{{ 'MAIN.EXPIRED_PAGE_TITLE' | translate }}</div>
    </div>
  `,
  styleUrls: ['./expired-link.component.scss'],
  standalone: false,
})
export class ExpiredLinkComponent {}
